<template>
  <div class="confirmacao-wrapper">
    <!-- Trigger: campo compacto acima do Controle -->
    <label>Definir Contato de Confirmação</label>
    <div class="flex flex-row space-x-2">
      <div class="chevron-trigger" @click="abrirSheet">
        <div class="chevron-trigger-content">
          <span v-if="contatoSelecionado" class="confirmacao-nome">
            <vs-icon icon="person" size="14px" color="success" />
            <span class="confirmacao-nome-texto">{{
              contatoSelecionado.nome
            }}</span>
            <span class="confirmacao-contato-valor"
              >— {{ contatoSelecionado.contato }}</span
            >
          </span>
          <span v-else-if="semContatosCadastrados" class="confirmacao-vazio">
            Nenhum contato cadastrado ainda. Cadastre um contato.
          </span>
          <span v-else class="confirmacao-vazio"
            >Nenhum contato selecionado</span
          >
        </div>
      </div>
      <div class="chevron-btn" @click.stop="abrirSheet">
        <vs-button
          size="small"
          type="relief"
          color="success"
          icon="chevron_right"
          icon-after
          >{{ semContatosCadastrados ? "Cadastrar" : "Definir" }}</vs-button
        >
      </div>
    </div>

    <!-- Sheet Lateral -->
    <transition name="sheet-slide">
      <div
        v-if="sheetAberto"
        class="confirmacao-sheet-overlay"
        @wheel.prevent
        @click.self="fecharSheet"
      >
        <div class="confirmacao-sheet">
          <!-- Header -->
          <div class="sheet-header">
            <div class="sheet-header-title">
              <span>Contato de Confirmação</span>
            </div>
            <div class="sheet-header-actions">
              <span class="cursor-pointer ml-3" @click.stop="fecharSheet">
                <vs-icon icon="close" size="20px" color="grey" />
              </span>
            </div>
          </div>

          <vs-divider class="my-2" />
          <div class="sheet-body" @wheel.prevent="onSheetWheel">
            <!-- Sem contatos cadastrados -->
            <div v-if="carregando" class="sheet-loading">
              <vs-icon icon="hourglass_empty" size="32px" color="grey" />
              <span>Carregando...</span>
            </div>

            <div v-else-if="contatos.length === 0" class="sheet-empty">
              <vs-icon icon="person_off" size="40px" color="warning" />
              <span class="sheet-empty-title">Nenhum contato cadastrado</span>
              <span class="sheet-empty-sub"
                >Cadastre um contato para continuar</span
              >
              <vs-button
                class="mt-3"
                size="small"
                color="primary"
                icon="person_add"
                @click="abrirEdicaoCompleta"
                >Cadastrar contato</vs-button
              >
            </div>

            <!-- Lista de contatos para seleção -->
            <div v-else class="sheet-lista">
              <span class="sheet-lista-hint"
                >Definir o responsável pela confirmação:</span
              >
              <div
                v-for="contato in contatosAtivos"
                :key="contato.id"
                class="sheet-item"
                :class="{
                  'sheet-item--ativo':
                    contatoSelecionado && contatoSelecionado.id === contato.id,
                }"
                @click="selecionarContato(contato)"
              >
                <div class="sheet-item-icon">
                  <vs-icon
                    :icon="contato.tipo == 1 ? 'alternate_email' : 'phone'"
                    size="18px"
                    :color="
                      contatoSelecionado && contatoSelecionado.id === contato.id
                        ? 'success'
                        : 'dark'
                    "
                  />
                </div>
                <div class="sheet-item-info">
                  <span class="sheet-item-nome">{{ contato.nome }}</span>
                  <span class="sheet-item-contato">{{ contato.contato }}</span>
                  <span v-if="contato.setor" class="sheet-item-setor">{{
                    contato.setor
                  }}</span>
                </div>
                <div class="sheet-item-check">
                  <vs-icon
                    v-if="
                      contatoSelecionado && contatoSelecionado.id === contato.id
                    "
                    icon="check_circle"
                    size="20px"
                    color="success"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Painel de edição de contatos (abre por cima da sheet) -->
    <transition name="sheet-slide">
      <div
        v-if="modalEdicaoAberto"
        class="confirmacao-sheet-overlay"
        @wheel.prevent
        @click.self="fecharEdicao"
      >
        <div class="confirmacao-sheet">
          <div class="sheet-header">
            <div class="sheet-header-title">
              <vs-icon icon="contacts" size="18px" color="dark" class="mr-2" />
              <span>Gerenciar Contatos</span>
            </div>
            <div class="sheet-header-actions">
              <span class="cursor-pointer" @click.stop="fecharEdicao">
                <vs-icon icon="close" size="20px" color="grey" />
              </span>
            </div>
          </div>
          <vs-divider class="my-2" />
          <add-contato
            :cliente="cliente"
            :edit="true"
            @contato-salvo="onContatoSalvo"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AddContato from "../../cliente/components/AddContato.vue";

export default {
  name: "SelecionarContatoConfirmacao",

  components: { AddContato },

  props: {
    cliente: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      sheetAberto: false,
      modalEdicaoAberto: false,
      contatos: [],
      carregando: false,
      contatoSelecionado: this.value || null,
      globalScrollLockAtivo: false,
    };
  },

  computed: {
    contatosAtivos() {
      // Apenas telefone (tipo=2), pois o envio de confirmação é via WhatsApp
      return this.contatos.filter((c) => c.lixeira == 0 && c.tipo == 2);
    },
    semContatosCadastrados() {
      return this.contatosAtivos.length === 0;
    },
  },

  watch: {
    value(val) {
      this.contatoSelecionado = val;
    },
    "cliente.id"() {
      this.getContatos();
    },
    sheetAberto() {
      this.updateBodyScrollLock();
    },
    modalEdicaoAberto() {
      this.updateBodyScrollLock();
    },
  },

  methods: {
    onGlobalWheel(event) {
      if (!this.sheetAberto && !this.modalEdicaoAberto) return;

      const target = event.target;
      const scrollEdicao = this.$el.querySelector(".scroll-add-contato");
      const scrollSheet = this.$el.querySelector(".sheet-body");

      if (
        this.modalEdicaoAberto &&
        scrollEdicao &&
        scrollEdicao.contains(target)
      ) {
        scrollEdicao.scrollTop += event.deltaY;
        event.preventDefault();
        return;
      }

      if (this.sheetAberto && scrollSheet && scrollSheet.contains(target)) {
        scrollSheet.scrollTop += event.deltaY;
        event.preventDefault();
        return;
      }

      event.preventDefault();
    },

    onGlobalTouchMove(event) {
      if (!this.sheetAberto && !this.modalEdicaoAberto) return;

      const target = event.target;
      const isDentroSheet =
        target && typeof target.closest === "function"
          ? !!target.closest(".confirmacao-sheet")
          : false;

      if (!isDentroSheet) {
        event.preventDefault();
      }
    },

    bindGlobalScrollLock() {
      if (this.globalScrollLockAtivo) return;

      globalThis.addEventListener("wheel", this.onGlobalWheel, {
        passive: false,
        capture: true,
      });
      globalThis.addEventListener("touchmove", this.onGlobalTouchMove, {
        passive: false,
        capture: true,
      });
      this.globalScrollLockAtivo = true;
    },

    unbindGlobalScrollLock() {
      if (!this.globalScrollLockAtivo) return;

      globalThis.removeEventListener("wheel", this.onGlobalWheel, true);
      globalThis.removeEventListener("touchmove", this.onGlobalTouchMove, true);
      this.globalScrollLockAtivo = false;
    },

    updateBodyScrollLock() {
      const deveTravar = this.sheetAberto || this.modalEdicaoAberto;
      const body = document.body;
      const html = document.documentElement;

      if (deveTravar) {
        body.style.overflow = "hidden";
        html.style.overflow = "hidden";
        this.bindGlobalScrollLock();
        return;
      }

      body.style.overflow = "";
      html.style.overflow = "";
      this.unbindGlobalScrollLock();
    },

    onSheetWheel(event) {
      const container = event.currentTarget;
      if (!container) return;
      container.scrollTop += event.deltaY;
    },

    async abrirSheet() {
      this.sheetAberto = true;
      await this.getContatos();
    },

    fecharSheet() {
      this.sheetAberto = false;
    },

    abrirEdicaoCompleta() {
      this.sheetAberto = false;
      this.modalEdicaoAberto = true;
    },

    fecharEdicao() {
      this.modalEdicaoAberto = false;
    },

    async onContatoSalvo() {
      await this.getContatos();
    },

    selecionarContato(contato) {
      this.contatoSelecionado = contato;
      this.$emit("input", contato);
      this.$emit("change", contato);
      this.fecharSheet();
    },

    async getContatos() {
      if (!this.cliente || !this.cliente.id) return;
      this.carregando = true;
      try {
        this.contatos = await this.$http.get(
          "contatoCliente/" + this.cliente.id,
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        this.carregando = false;
      }
    },
  },
  async mounted() {
    this.updateBodyScrollLock();
    await this.getContatos();
  },
  beforeDestroy() {
    const body = document.body;
    const html = document.documentElement;
    body.style.overflow = "";
    html.style.overflow = "";
    this.unbindGlobalScrollLock();
  },
};
</script>

<style scoped>
/* ── Trigger ── */
.confirmacao-wrapper {
  position: relative;
  margin-bottom: 12px;
}

.chevron-trigger {
  display: flex;
  align-items: stretch;
  width: 18rem;
  max-width: 100%;
  border: 1px solid #dae1e7;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  background: #fff;
}

.chevron-trigger-content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  overflow: hidden;
}

.chevron-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.confirmacao-nome {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  min-width: 0;
  overflow: hidden;
}

.confirmacao-nome-texto {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.confirmacao-contato-valor {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  flex-shrink: 0;
}

.confirmacao-vazio {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #94a3b8;
}

/* ── Sheet Overlay ── */
.confirmacao-sheet-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 99990;
  display: flex;
  justify-content: flex-end;
  overscroll-behavior: contain;
}

.confirmacao-sheet {
  width: 360px;
  max-width: 95vw;
  height: 100vh;
  background: #fff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  overflow: hidden;
}

.sheet-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 2px;
}

/* ── Header ── */
.sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sheet-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.sheet-header-actions {
  display: flex;
  align-items: center;
}

/* ── Loading / Empty ── */
.sheet-loading,
.sheet-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 0;
  color: #94a3b8;
  text-align: center;
}

.sheet-empty-title {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}

.sheet-empty-sub {
  font-size: 12px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 3px;
}

/* ── Lista ── */
.sheet-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sheet-lista-hint {
  font-size: 11px;
  color: #3a4048;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.sheet-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.sheet-item:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.sheet-item--ativo {
  border-color: #22c55e !important;
  background: #f0fdf4 !important;
}

.sheet-item-icon {
  flex-shrink: 0;
}

.sheet-item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.sheet-item-nome {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sheet-item-contato {
  font-size: 12px;
  color: #64748b;
}

.sheet-item-setor {
  font-size: 11px;
  color: #7d8b9d;
  text-transform: uppercase;
}

.sheet-item-check {
  flex-shrink: 0;
}

/* ── Animação ── */
.sheet-slide-enter-active,
.sheet-slide-leave-active {
  transition: opacity 0.2s ease;
}

.sheet-slide-enter-active .confirmacao-sheet,
.sheet-slide-leave-active .confirmacao-sheet {
  transition: transform 0.25s ease;
}

.sheet-slide-enter .confirmacao-sheet,
.sheet-slide-leave-to .confirmacao-sheet {
  transform: translateX(100%);
}

.sheet-slide-enter,
.sheet-slide-leave-to {
  opacity: 0;
}
</style>
